import React from "react";
import { useTranslation } from "react-i18next";
import {
  LanguageButton,
  LanguageToggleWrapper,
} from "./styles";

const LanguageToggle: React.FC = () => {
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language.startsWith("en") ? "en" : "sr";

  const changeLanguage = (language: "sr" | "en") => {
    i18n.changeLanguage(language);
    localStorage.setItem("selectedLanguage", language);
  };

  return (
    <LanguageToggleWrapper>
      <LanguageButton
        type="button"
        $active={currentLanguage === "sr"}
        onClick={() => changeLanguage("sr")}
      >
        SR
      </LanguageButton>

      <LanguageButton
        type="button"
        $active={currentLanguage === "en"}
        onClick={() => changeLanguage("en")}
      >
        EN
      </LanguageButton>
    </LanguageToggleWrapper>
  );
};

export default LanguageToggle;